import { dew as _FetcherDew } from "./Fetcher";
import { dew as _SupplierDew } from "./Supplier";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Supplier = exports.fetcher = void 0;
  var Fetcher_1 = _FetcherDew();
  Object.defineProperty(exports, "fetcher", {
    enumerable: true,
    get: function () {
      return Fetcher_1.fetcher;
    }
  });
  var Supplier_1 = _SupplierDew();
  Object.defineProperty(exports, "Supplier", {
    enumerable: true,
    get: function () {
      return Supplier_1.Supplier;
    }
  });
  return exports;
}